import { c as _c } from "react-compiler-runtime";
import { useEffect, useRef } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
export const useFrozenColumnWidthAlert = (columns, frozenOffsets, scrollContainerRef, onFrozenColumnWidthAlert) => {
  const $ = _c(6);
  const widthAlertShownRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== columns || $[1] !== frozenOffsets || $[2] !== onFrozenColumnWidthAlert || $[3] !== scrollContainerRef) {
    t0 = () => {
      var _scrollContainerRef$c;
      const containerBoundingClient = scrollContainerRef === null || scrollContainerRef === void 0 || (_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 ? void 0 : _scrollContainerRef$c.getBoundingClientRect();
      const hasFrozenColumns = containerBoundingClient && columns.length && frozenOffsets.length;
      if (!hasFrozenColumns) {
        widthAlertShownRef.current = false;
        return;
      }
      const lastFrozenColumnRightOffset = frozenOffsets[frozenOffsets.length - 1] + columns[frozenOffsets.length - 1].width;
      const isFrozenColumnWiderThanTable = containerBoundingClient.width < lastFrozenColumnRightOffset;
      if (isFrozenColumnWiderThanTable && !widthAlertShownRef.current) {
        widthAlertShownRef.current = true;
        FloatingAlertStore.addAlert({
          message: I18n.text("datatable.frozenColumn.widthError"),
          type: "warning",
          timeout: 12000,
          "data-test-id": "frozen-column-width-alert"
        });
        onFrozenColumnWidthAlert === null || onFrozenColumnWidthAlert === void 0 || onFrozenColumnWidthAlert();
      } else {
        if (!isFrozenColumnWiderThanTable && widthAlertShownRef.current) {
          widthAlertShownRef.current = false;
        }
      }
    };
    t1 = [columns, frozenOffsets, scrollContainerRef, onFrozenColumnWidthAlert];
    $[0] = columns;
    $[1] = frozenOffsets;
    $[2] = onFrozenColumnWidthAlert;
    $[3] = scrollContainerRef;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
};